import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { authData } from "src/app/util/auth";
import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-application-referral",
  templateUrl: "./application-referral.component.html",
})
export class ApplicationReferralComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}

  payload: any = {};
  form = { unit: false, course: false };

  notification = {};
  downloader: any = null;

  loading = false;
  refreshing = false;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    const { HasExtraYear, ReferralApplicationType } = authData("_checks");
    if (!HasExtraYear || ReferralApplicationType < 1) {
      this.router.navigateByUrl("/application");
    }

    this.form.unit = ReferralApplicationType == 1;
    this.form.course = ReferralApplicationType == 2;

    const baseUrl = `${environment.BASE_URL}/payments/referralApplication`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.payload = res.Data;
        } else {
          this.notification = errorHandler(res);
        }
        this.refreshing = false;
      },
      error: (err) => {
        this.refreshing = false;
        this.notification = errorHandler(err);
      },
    });
  }

  submitForm() {
    this.loading = true;
    this.notification = {};

    const baseUrl = `${environment.BASE_URL}/payments/saveReferralApplication`;
    this.httpClient.post(baseUrl, this.payload, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.router.navigateByUrl(
            "/payments#Referral+Application+Submitted.+Please+proceed+with+the+payment"
          );
        } else {
          this.notification = errorHandler(res);
        }
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      },
    });
  }
}
